import Typography from '../../../components/Typography';
import Section from '../../../components/Section';
import Button from '../../../components/Button';
import styles from './Home.module.scss';

function Home() {
  return (
    <Section
      containerClassName={styles.background}
      className={styles.container}
    >
      <div className={styles.imgFrame}>
        <img
          src={require('../../../assets/review-animation.gif')}
          className={styles.img}
          alt="Clipboard"
          width="256"
        />
      </div>
      <div className={styles.content}>
        <Typography textType="h1" as="h1">
          Reviews Simplified,
          <br />
          Results Amplified.
        </Typography>
        <Typography textType="h3" as="p">
          Automate replies to your Google Reviews using AI responses
        </Typography>
        <div className={styles.actions}>
          <Button
            as="a"
            href="/reviews"
            target="_blank"
            rel="noreferrer noopener"
            variant="solid"
            buttonColor="primary-1"
          >
            Get Started
          </Button>
          <Button as="a" href="#why" variant="outline">
            Learn More
          </Button>
        </div>
        <Typography textType="h3" as="p">
          No hidden fees or charges. Free to use. Just one click away.
        </Typography>
        <a
          href={process.env.REACT_APP_EXTENSION_LINK}
          target="_blank"
          rel="noreferrer noopener"
        >
          <img
            className={styles.chrome}
            src={require('../../../assets/chrome-web-store.png')}
            alt="Available in the chrome webstore"
            width="200"
          />
        </a>
      </div>
    </Section>
  );
}

Home.routeProps = {
  priority: 3,
  label: 'Home',
};
export default Home;
